import React from 'react';
import Modal from '../../../client/components/Modal';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import CustomerActions from '../../actions/CustomerActions';
import CustomerStore from '../../stores/CustomerStore';
import StoreStore from '../../stores/StoreStore';
import { RequestStates } from '../../stores/PaginatedStore';
import menuClosePng from '../images/button_menu_close.png';
import menuCloseSvg from '../images/button_menu_close.svg';
import styles from './index.sass';

class ZipCodeModal extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    getUserAgent: React.PropTypes.func,
    trackEvent: React.PropTypes.func
  };

  static propTypes = {
    customer      : React.PropTypes.object,
    store         : React.PropTypes.object,
    requestStatus : React.PropTypes.string,
    onClose       : React.PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = this.getStateFromProps(props);
    this.scrollTop = 0;
  }

  getStateFromProps(props) {
    let zipCode = props.customer && props.customer.preferences.zip_code ? props.customer.preferences.zip_code : '';
    return {
      error         : null,
      loading       : false,
      requestStatus : props.requestStatus,
      zipCode       : zipCode
    };
  }

  componentDidMount() {
    // this.scrollTop = document.body.scrollTop;
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
    // document.body.style.position = 'fixed';

    this.context.trackEvent('view', {value: 'zip'});
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
    document.body.style.width = '';
    // document.body.style.position = '';
    // document.body.scrollTop = this.scrollTop;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    if(this.state.loading && this.state.requestStatus === RequestStates.Loading) {
      if(nextProps.requestStatus === RequestStates.Done) {
        this.props.onClose(true);
      }
      if(nextProps.requestStatus === RequestStates.Done || nextProps.requestStatus === RequestStates.Error) {
        this.setState({loading: false});
      }
    }
    if(nextProps.requestStatus) {
      this.setState({requestStatus: nextProps.requestStatus});
    }
  }

  handleOnChangeZipcode(e) {
    this.setState({
      zipCode: e.target.value
    });
  }

  handleOnKeyDown(e) {
    if(e.which === 13 && !this.state.loading) {
      this.handleOnClickSubmitButton();
    }
  }

  handleOnClickSubmitButton(e) {
    if(!validateZipcode(this.state.zipCode)) {return;}
    this.setState({
      loading: true
    });
    let payload = {
      preferences: [
        {key: 'zip_code', value: this.state.zipCode}
      ]
    };
    if(this.props.customer) {
      this.context.executeAction(CustomerActions.updatePreferences, payload);
    } else {
      this.context.executeAction(CustomerActions.auth, payload);
    }
  }

  handleOnCloseModal() {
    this.props.onClose(false);
  }

  render() {
    let isMobile = this.context.getUserAgent().isMobile;
    let modalProps = {
      onClose   : this.handleOnCloseModal.bind(this),
      className : styles.zipCodeModal
    };
    let zipCodeInputProps = {
      className : styles.zipCodeInput,
      placeholder: 'Enter zip code',
      onChange: this.handleOnChangeZipcode.bind(this),
      onKeyDown: this.handleOnKeyDown.bind(this),
      type: isMobile ? 'tel' : 'text',
      maxLength: 5,
      autoFocus: isMobile ? false : true,
      value: this.state.zipCode
    };
    let submitButtonProps = {
      className: styles.submitButton,
      onClick: this.handleOnClickSubmitButton.bind(this),
      disabled: this.state.loading || !validateZipcode(this.state.zipCode)
    };
    let buttonContent = this.state.loading ? <span className="loading-spinner--white" /> : 'Continue';
    let policyUrl = '';
    if(this.props.store && this.props.store.policy_url) {
      policyUrl = <span> and agree to our <a href={this.props.store.policy_url} target="_blank">Terms of Service</a></span>;
    }

    return (
      <Modal {...modalProps}>
        <div className={styles.modalContents}>
          <button className={styles.closeButton} onClick={this.handleOnCloseModal.bind(this)}>
            <img src={menuClosePng} srcSet={menuCloseSvg} />
          </button>
          <h2 className={styles.header}>We just need your zip code</h2>
          <p className={styles.subheader}>...in order to provide accurate shipping options</p>
          <input {...zipCodeInputProps} />
          <button {...submitButtonProps}>{buttonContent}</button>
          <small className={styles.smallText}>By clicking “Continue” you verify that you are 21 years or older{policyUrl}</small>
        </div>
      </Modal>
    );
  }
}

ZipCodeModal = connectToStores(ZipCodeModal, [CustomerStore, StoreStore], (context, props) => {
  let customerStore = context.getStore(CustomerStore);
  return {
    customer: customerStore.getCurrentCustomer(),
    requestStatus: customerStore.getCurrentRequestStatus(),
    error: customerStore.getCurrentError(),
    store: context.getStore(StoreStore).getCurrentStore()
  };
});

export default ZipCodeModal;

function validateZipcode(zipCode) {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode);
}



// WEBPACK FOOTER //
// banquet/components/ZipCodeModal/index.js